// Countries for the organisation profile (Finance): ISO code, name, local currency, main time zone, and defaults
// that pre-fill the profile (all editable): working days, the main sales tax, the customs authority, the date format
// and the customs valuation basis for duty estimates. Nothing in Falcon is tied to one country.

export interface Country { code: string; name: string; currency: string; tz: string }
// code|name|currency|timezone
const RAW = `AF|Afghanistan|AFN|Asia/Kabul
AL|Albania|ALL|Europe/Tirane
DZ|Algeria|DZD|Africa/Algiers
AD|Andorra|EUR|Europe/Andorra
AO|Angola|AOA|Africa/Luanda
AG|Antigua and Barbuda|XCD|America/Antigua
AR|Argentina|ARS|America/Argentina/Buenos_Aires
AM|Armenia|AMD|Asia/Yerevan
AU|Australia|AUD|Australia/Sydney
AT|Austria|EUR|Europe/Vienna
AZ|Azerbaijan|AZN|Asia/Baku
BS|Bahamas|BSD|America/Nassau
BH|Bahrain|BHD|Asia/Bahrain
BD|Bangladesh|BDT|Asia/Dhaka
BB|Barbados|BBD|America/Barbados
BY|Belarus|BYN|Europe/Minsk
BE|Belgium|EUR|Europe/Brussels
BZ|Belize|BZD|America/Belize
BJ|Benin|XOF|Africa/Porto-Novo
BT|Bhutan|BTN|Asia/Thimphu
BO|Bolivia|BOB|America/La_Paz
BA|Bosnia and Herzegovina|BAM|Europe/Sarajevo
BW|Botswana|BWP|Africa/Gaborone
BR|Brazil|BRL|America/Sao_Paulo
BN|Brunei|BND|Asia/Brunei
BG|Bulgaria|BGN|Europe/Sofia
BF|Burkina Faso|XOF|Africa/Ouagadougou
BI|Burundi|BIF|Africa/Bujumbura
KH|Cambodia|KHR|Asia/Phnom_Penh
CM|Cameroon|XAF|Africa/Douala
CA|Canada|CAD|America/Toronto
CV|Cape Verde|CVE|Atlantic/Cape_Verde
CF|Central African Republic|XAF|Africa/Bangui
TD|Chad|XAF|Africa/Ndjamena
CL|Chile|CLP|America/Santiago
CN|China|CNY|Asia/Shanghai
CO|Colombia|COP|America/Bogota
KM|Comoros|KMF|Indian/Comoro
CG|Congo|XAF|Africa/Brazzaville
CD|Congo (DRC)|CDF|Africa/Kinshasa
CR|Costa Rica|CRC|America/Costa_Rica
CI|Côte d'Ivoire|XOF|Africa/Abidjan
HR|Croatia|EUR|Europe/Zagreb
CU|Cuba|CUP|America/Havana
CY|Cyprus|EUR|Asia/Nicosia
CZ|Czech Republic|CZK|Europe/Prague
DK|Denmark|DKK|Europe/Copenhagen
DJ|Djibouti|DJF|Africa/Djibouti
DM|Dominica|XCD|America/Dominica
DO|Dominican Republic|DOP|America/Santo_Domingo
EC|Ecuador|USD|America/Guayaquil
EG|Egypt|EGP|Africa/Cairo
SV|El Salvador|USD|America/El_Salvador
GQ|Equatorial Guinea|XAF|Africa/Malabo
ER|Eritrea|ERN|Africa/Asmara
EE|Estonia|EUR|Europe/Tallinn
SZ|Eswatini|SZL|Africa/Mbabane
ET|Ethiopia|ETB|Africa/Addis_Ababa
FJ|Fiji|FJD|Pacific/Fiji
FI|Finland|EUR|Europe/Helsinki
FR|France|EUR|Europe/Paris
GA|Gabon|XAF|Africa/Libreville
GM|Gambia|GMD|Africa/Banjul
GE|Georgia|GEL|Asia/Tbilisi
DE|Germany|EUR|Europe/Berlin
GH|Ghana|GHS|Africa/Accra
GR|Greece|EUR|Europe/Athens
GD|Grenada|XCD|America/Grenada
GT|Guatemala|GTQ|America/Guatemala
GN|Guinea|GNF|Africa/Conakry
GW|Guinea-Bissau|XOF|Africa/Bissau
GY|Guyana|GYD|America/Guyana
HT|Haiti|HTG|America/Port-au-Prince
HN|Honduras|HNL|America/Tegucigalpa
HK|Hong Kong|HKD|Asia/Hong_Kong
HU|Hungary|HUF|Europe/Budapest
IS|Iceland|ISK|Atlantic/Reykjavik
IN|India|INR|Asia/Kolkata
ID|Indonesia|IDR|Asia/Jakarta
IR|Iran|IRR|Asia/Tehran
IQ|Iraq|IQD|Asia/Baghdad
IE|Ireland|EUR|Europe/Dublin
IL|Israel|ILS|Asia/Jerusalem
IT|Italy|EUR|Europe/Rome
JM|Jamaica|JMD|America/Jamaica
JP|Japan|JPY|Asia/Tokyo
JO|Jordan|JOD|Asia/Amman
KZ|Kazakhstan|KZT|Asia/Almaty
KE|Kenya|KES|Africa/Nairobi
KW|Kuwait|KWD|Asia/Kuwait
KG|Kyrgyzstan|KGS|Asia/Bishkek
LA|Laos|LAK|Asia/Vientiane
LV|Latvia|EUR|Europe/Riga
LB|Lebanon|LBP|Asia/Beirut
LS|Lesotho|LSL|Africa/Maseru
LR|Liberia|LRD|Africa/Monrovia
LY|Libya|LYD|Africa/Tripoli
LI|Liechtenstein|CHF|Europe/Vaduz
LT|Lithuania|EUR|Europe/Vilnius
LU|Luxembourg|EUR|Europe/Luxembourg
MO|Macau|MOP|Asia/Macau
MG|Madagascar|MGA|Indian/Antananarivo
MW|Malawi|MWK|Africa/Blantyre
MY|Malaysia|MYR|Asia/Kuala_Lumpur
MV|Maldives|MVR|Indian/Maldives
ML|Mali|XOF|Africa/Bamako
MT|Malta|EUR|Europe/Malta
MR|Mauritania|MRU|Africa/Nouakchott
MU|Mauritius|MUR|Indian/Mauritius
MX|Mexico|MXN|America/Mexico_City
MD|Moldova|MDL|Europe/Chisinau
MC|Monaco|EUR|Europe/Monaco
MN|Mongolia|MNT|Asia/Ulaanbaatar
ME|Montenegro|EUR|Europe/Podgorica
MA|Morocco|MAD|Africa/Casablanca
MZ|Mozambique|MZN|Africa/Maputo
MM|Myanmar|MMK|Asia/Yangon
NA|Namibia|NAD|Africa/Windhoek
NP|Nepal|NPR|Asia/Kathmandu
NL|Netherlands|EUR|Europe/Amsterdam
NZ|New Zealand|NZD|Pacific/Auckland
NI|Nicaragua|NIO|America/Managua
NE|Niger|XOF|Africa/Niamey
NG|Nigeria|NGN|Africa/Lagos
MK|North Macedonia|MKD|Europe/Skopje
NO|Norway|NOK|Europe/Oslo
OM|Oman|OMR|Asia/Muscat
PK|Pakistan|PKR|Asia/Karachi
PA|Panama|PAB|America/Panama
PG|Papua New Guinea|PGK|Pacific/Port_Moresby
PY|Paraguay|PYG|America/Asuncion
PE|Peru|PEN|America/Lima
PH|Philippines|PHP|Asia/Manila
PL|Poland|PLN|Europe/Warsaw
PT|Portugal|EUR|Europe/Lisbon
QA|Qatar|QAR|Asia/Qatar
RO|Romania|RON|Europe/Bucharest
RU|Russia|RUB|Europe/Moscow
RW|Rwanda|RWF|Africa/Kigali
SA|Saudi Arabia|SAR|Asia/Riyadh
SN|Senegal|XOF|Africa/Dakar
RS|Serbia|RSD|Europe/Belgrade
SC|Seychelles|SCR|Indian/Mahe
SL|Sierra Leone|SLE|Africa/Freetown
SG|Singapore|SGD|Asia/Singapore
SK|Slovakia|EUR|Europe/Bratislava
SI|Slovenia|EUR|Europe/Ljubljana
SO|Somalia|SOS|Africa/Mogadishu
ZA|South Africa|ZAR|Africa/Johannesburg
KR|South Korea|KRW|Asia/Seoul
SS|South Sudan|SSP|Africa/Juba
ES|Spain|EUR|Europe/Madrid
LK|Sri Lanka|LKR|Asia/Colombo
SD|Sudan|SDG|Africa/Khartoum
SR|Suriname|SRD|America/Paramaribo
SE|Sweden|SEK|Europe/Stockholm
CH|Switzerland|CHF|Europe/Zurich
SY|Syria|SYP|Asia/Damascus
TW|Taiwan|TWD|Asia/Taipei
TJ|Tajikistan|TJS|Asia/Dushanbe
TZ|Tanzania|TZS|Africa/Dar_es_Salaam
TH|Thailand|THB|Asia/Bangkok
TG|Togo|XOF|Africa/Lome
TT|Trinidad and Tobago|TTD|America/Port_of_Spain
TN|Tunisia|TND|Africa/Tunis
TR|Türkiye|TRY|Europe/Istanbul
TM|Turkmenistan|TMT|Asia/Ashgabat
UG|Uganda|UGX|Africa/Kampala
UA|Ukraine|UAH|Europe/Kyiv
AE|United Arab Emirates|AED|Asia/Dubai
GB|United Kingdom|GBP|Europe/London
US|United States|USD|America/New_York
UY|Uruguay|UYU|America/Montevideo
UZ|Uzbekistan|UZS|Asia/Tashkent
VE|Venezuela|VES|America/Caracas
VN|Vietnam|VND|Asia/Ho_Chi_Minh
YE|Yemen|YER|Asia/Aden
ZM|Zambia|ZMW|Africa/Lusaka
ZW|Zimbabwe|ZWG|Africa/Harare`;

export const COUNTRIES: Country[] = RAW.split("\n").map((l) => { const [code, name, currency, tz] = l.split("|"); return { code, name, currency, tz }; });
export const countryByCode = (code: string | null | undefined) => COUNTRIES.find((c) => c.code === String(code || "").toUpperCase()) || null;
/** Match a free-text country name (e.g. the address country) to the list. */
export function countryByName(name: string | null | undefined): Country | null {
  const n = String(name || "").trim().toLowerCase();
  if (!n) return null;
  const alias: Record<string, string> = { uk: "GB", "great britain": "GB", england: "GB", scotland: "GB", wales: "GB", usa: "US", "united states of america": "US", ksa: "SA", uae: "AE", turkey: "TR", "south korea": "KR", korea: "KR" };
  if (alias[n]) return countryByCode(alias[n]);
  return COUNTRIES.find((c) => c.name.toLowerCase() === n || c.code.toLowerCase() === n) || null;
}

/** Every currency Falcon offers (the countries' currencies plus the common trading ones), sorted. */
export const ALL_CURRENCIES: string[] = [...new Set(["USD", "EUR", "GBP", "CNY", "HKD", "JPY", ...COUNTRIES.map((c) => c.currency)])].sort();
export const isCurrency = (v: unknown): v is string => typeof v === "string" && ALL_CURRENCIES.includes(v);

// Weekdays: 0 = Sunday … 6 = Saturday.
const SUN_THU = ["SA", "BH", "KW", "OM", "QA", "EG", "JO", "IQ", "DZ", "BD", "IL", "LY", "SD", "SY", "YE"];
const SAT_THU = ["IR", "AF"];
const TAX: Record<string, [string, number]> = {
  SA: ["VAT", 15], AE: ["VAT", 5], BH: ["VAT", 10], OM: ["VAT", 5], QA: ["VAT", 0], KW: ["VAT", 0], GB: ["VAT", 20], IE: ["VAT", 23], DE: ["VAT", 19], FR: ["VAT", 20],
  IT: ["VAT", 22], ES: ["VAT", 21], NL: ["VAT", 21], BE: ["VAT", 21], PT: ["VAT", 23], AT: ["VAT", 20], PL: ["VAT", 23], SE: ["VAT", 25], DK: ["VAT", 25], FI: ["VAT", 25.5],
  CZ: ["VAT", 21], GR: ["VAT", 24], HU: ["VAT", 27], RO: ["VAT", 19], BG: ["VAT", 20], HR: ["VAT", 25], SK: ["VAT", 23], SI: ["VAT", 22], LT: ["VAT", 21], LV: ["VAT", 21], EE: ["VAT", 22],
  LU: ["VAT", 17], CY: ["VAT", 19], MT: ["VAT", 18], NO: ["VAT", 25], CH: ["VAT", 8.1], TR: ["KDV", 20], EG: ["VAT", 14], JO: ["Sales tax", 16], PK: ["Sales tax", 18],
  BD: ["VAT", 15], IN: ["IGST", 12], LK: ["VAT", 18], CN: ["VAT", 13], JP: ["Consumption tax", 10], KR: ["VAT", 10], SG: ["GST", 9], MY: ["SST", 10], TH: ["VAT", 7],
  VN: ["VAT", 10], ID: ["VAT", 11], PH: ["VAT", 12], AU: ["GST", 10], NZ: ["GST", 15], CA: ["GST", 5], US: ["Sales tax", 0], MX: ["IVA", 16], BR: ["ICMS", 18],
  ZA: ["VAT", 15], MA: ["VAT", 20], TN: ["VAT", 19], KE: ["VAT", 16], NG: ["VAT", 7.5],
};
const CUSTOMS: Record<string, string> = {
  SA: "ZATCA", GB: "HMRC", US: "CBP", AE: "Federal Authority for Identity, Citizenship, Customs & Port Security", CA: "CBSA", AU: "Australian Border Force",
  NZ: "New Zealand Customs Service", IE: "Revenue", DE: "Zoll", FR: "Douane", NL: "Douane", IN: "CBIC", PK: "Pakistan Customs", BD: "NBR Customs", CN: "GACC",
  TR: "Turkish Customs", EG: "Egyptian Customs Authority", QA: "General Authority of Customs", KW: "Kuwait General Administration of Customs", BH: "Bahrain Customs",
  OM: "Royal Oman Police Customs", JP: "Japan Customs", SG: "Singapore Customs", ZA: "SARS Customs",
};
// Customs value for duty: CIF (goods + freight + insurance) in most countries; FOB in these.
const FOB_VALUATION = ["US", "CA", "AU", "NZ", "ZA", "BW", "LS", "NA", "SZ"];
const MDY = ["US", "PH", "BZ"];
const YMD = ["CN", "JP", "KR", "TW", "HU", "LT", "SE", "MN"];

export type DateFormat = "dd/mm/yyyy" | "mm/dd/yyyy" | "yyyy-mm-dd";
export type NumberFormat = "1,234.56" | "1.234,56" | "1 234,56";
export interface CountryDefaults {
  workingDays: number[]; taxName: string; taxRate: number; customsAuthority: string; dateFormat: DateFormat; numberFormat: NumberFormat; valuation: "CIF" | "FOB";
}
const COMMA_DECIMAL = ["DE", "FR", "IT", "ES", "NL", "BE", "PT", "AT", "PL", "SE", "DK", "FI", "CZ", "GR", "HU", "RO", "BG", "HR", "SK", "SI", "LT", "LV", "EE", "NO", "TR", "BR", "AR", "CL", "CO", "ID", "VN", "RU", "UA"];
const SPACE_GROUP = ["FR", "SE", "FI", "NO", "CZ", "SK", "PL", "HU", "RU", "UA", "LT", "LV", "EE", "BG"];
export function countryDefaults(code: string | null | undefined): CountryDefaults {
  const c = String(code || "").toUpperCase();
  const [taxName, taxRate] = TAX[c] || ["VAT", 0];
  return {
    workingDays: SUN_THU.includes(c) ? [0, 1, 2, 3, 4] : SAT_THU.includes(c) ? [6, 0, 1, 2, 3, 4] : [1, 2, 3, 4, 5],
    taxName, taxRate, customsAuthority: CUSTOMS[c] || "Customs", dateFormat: MDY.includes(c) ? "mm/dd/yyyy" : YMD.includes(c) ? "yyyy-mm-dd" : "dd/mm/yyyy",
    numberFormat: SPACE_GROUP.includes(c) ? "1 234,56" : COMMA_DECIMAL.includes(c) ? "1.234,56" : "1,234.56", valuation: FOB_VALUATION.includes(c) ? "FOB" : "CIF",
  };
}
export const WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

/** Conformity certificate schemes suggested per destination country (editable in Settings → Finance → Customs). */
export const DEFAULT_CONFORMITY: Record<string, string[]> = {
  SA: ["SABER product certificate", "SABER shipment certificate"], GB: ["UKCA"], US: ["CPC"], AE: ["ECAS"],
  ...Object.fromEntries(["DE", "FR", "IT", "ES", "NL", "BE", "PT", "AT", "PL", "SE", "DK", "FI", "IE", "CZ", "GR", "HU", "RO", "BG", "HR", "SK", "SI", "LT", "LV", "EE", "LU", "CY", "MT"].map((c) => [c, ["CE"]])),
};
